import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { isNotNil } from '@web/utils';
import {
  DateComponent,
  DetailsViewComponent,
  NumberComponent,
} from '@web/shared/ui';

@Component({
  selector: 'app-warehouse-release-details-product-attributes',
  imports: [DateComponent, DetailsViewComponent, NumberComponent],
  templateUrl: './warehouse-release-details-product-attributes.component.html',
  styleUrl: './warehouse-release-details-product-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReleaseDetailsProductAttributesComponent {
  public readonly brandName = input.required<string>();
  public readonly sku = input.required<string>();
  public readonly name = input.required<string>();
  public readonly createdAt = input.required<Date>();
  public readonly quantity = input.required<number>();

  protected readonly isNotNil = isNotNil;
}
